<template>
  <footer id="theFooter" class="bg-azure-dark p-3 p-md-5 footer sticky-bottom">
    <template v-if="!$store.getters.isAuthenticated" >
      <div class="row">
        <div class="col-md-4 vert-center" >
          <router-link :to="{ name: 'SecurityAssignment' }" tag="button" class="btn btn-outline-azure-light btn-wide btn-lg" aria-label="Direct opdracht insturen">
            <span>Een vrijblijvende <br> offerte aanvragen</span>
            <div class="btn-icon">
                <span>&rarr;</span>
            </div>
          </router-link>
        </div>
        <div class="col-md-4 mt-3 pl-lg-5 pr-lg-5" >
          <div class="row text-center vert-center">
            <div class="col-6">
              <router-link tag="a" :to="{ name: 'InformationSecurity'}">
                <img src="@/assets/beveiliging/beveiliger-embleem.webp" :height="[$store.getters.isSmall ? '60' : '120']" alt="Logo Beveiliging" title="Logo Beveiliging" />
              </router-link>
            </div>
            <div class="col-6">
              <router-link tag="a" :to="{ name: 'InformationSecurity'}">
                <img src="@/assets/justis_nd5590.webp" :height="[$store.getters.isSmall ? '60' : '120']" alt="Logo Beveiliging" title="Logo Beveiliging" />
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-md-2 mt-3">
          <ul class="p-0">
            <li class="mb-3">
              <router-link :to="{ name: 'SecurityAbout' }" tag="a" >Over Azurity</router-link>
            </li>
            <li class="mb-3">
              <router-link :to="{ name: 'InformationClient' }" tag="a" >Opdrachtgever</router-link>
            </li>
            <li class="mb-3">
              <router-link :to="{ name: 'InformationProfessional' }" tag="a" >Beveiliger</router-link>
            </li>
            <li class="mb-3">
              <router-link :to="{ name: 'SecurityVacancies' }" tag="a" >Werken Bij Ons</router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-2 mt-md-3">
          <ul class="p-0">
            <li class="mb-3">
              <router-link :to="{ name: 'SecurityReferral' }" tag="a" >Referral Programma</router-link>
            </li>
            <li class="mb-3">
              <router-link :to="{ name: 'SecurityFAQ' }" tag="a" >FAQ - Vragen</router-link>
            </li>
            <li class="mb-3">
              <router-link :to="{ name: 'SecurityPartners' }" tag="a" >Partners</router-link>
            </li>
            <li class="mb-3">
              <router-link :to="{ name: 'SecurityContact' }" tag="a" >Contact</router-link>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <div class="col-md-12">
      <div class="text-center" v-if="$store.getters.isAuthenticated">
        Een fout gezien of een suggestie? <a :href="mailError">Meld het ons</a>.
      </div>
      <hr>
      <div :class="[$store.getters.isSmall ? 'text-center mb-3' : 'inline mr-5']">
        <strong>
          &copy; {{new Date().getFullYear()}} - Azurity <span v-show="!$store.getters.isSmall">Beveiliging B.V.</span><br />
          <small v-show="!$store.getters.isSmall">Endegeesterstraatweg 3, 2342 AJ, Oegstgeest</small>
        </strong>
      </div>
      <div :class="[ $store.getters.isSmall ? 'text-center mb-3' : 'inline']">
        <a rel="noreferrer" href="https://azurity-beveiliging.business.site/" target="_blank" :class="['icon', $store.getters.isSmall ? 'm-2' : 'mr-3']" alt="instagram" title="Azurity Google">
          <font-awesome-icon :icon="['fab', 'google']" :class="[$store.getters.isSmall ? 'fa-2x' : 'fa-3x']" />
        </a>
        <a rel="noreferrer" href="https://www.linkedin.com/in/azurity/" target="_blank" :class="['icon', $store.getters.isSmall ? 'm-2' : 'mr-3']" alt="instagram" title="Azurity LinkedIn">
          <font-awesome-icon :icon="['fab', 'linkedin']" :class="[$store.getters.isSmall ? 'fa-2x' : 'fa-3x']" />
        </a>
        <a rel="noreferrer" href="https://www.instagram.com/azuritybeveiliging/" target="_blank" :class="['icon', $store.getters.isSmall ? 'm-2' : 'mr-3']" alt="instagram" title="Azurity Instagram">
          <font-awesome-icon :icon="['fab', 'instagram']" :class="[$store.getters.isSmall ? 'fa-2x' : 'fa-3x']" />
        </a>
        <a rel="noreferrer" href="https://www.facebook.com/azurityNL/" target="_blank" :class="['icon', $store.getters.isSmall ? 'm-2' : 'mr-3']" alt="instagram" title="Azurity Facebook">
          <font-awesome-icon :icon="['fab', 'facebook']" :class="[$store.getters.isSmall ? 'fa-2x' : 'fa-3x']" />
        </a>
      </div>
      <div :class="[ $store.getters.isSmall ? 'text-center' : 'right inline']">
        <label for="footer-nav" class="footer-nav-label">Navigatie</label>
        <select class="form-control nav-menu inline" placeholder="Navigatie" @change="navigate" id="footer-nav" name="footer-nav">
          <optgroup  label="Pagina's">
            <option :value="r.path" v-for="r in routes" :key="r.path" >
              <a :href="r.path">
                <span v-for="i in r.id" :key="i">&nbsp;&nbsp;</span>{{r.name}}
              </a>
            </option>
          </optgroup>
          <optgroup  label="Regio Rijnland">
            <option value="/security-beveiligingsbedrijf/plaats/Alphen%20aan%20den%20Rijn" >
              <a href="/security-beveiligingsbedrijf/plaats/Alphen%20aan%20den%20Rijn">Alphen aan de Rijn</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/hillegom" >
              <a href="/security-beveiligingsbedrijf/plaats/hillegom">Hillegom</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/kaagenbraassem" >
              <a href="/security-beveiligingsbedrijf/plaats/kaagenbraassem">Kaag en Braassem</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/katwijk" >
              <a href="/security-beveiligingsbedrijf/plaats/katwijk">Katwijk</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/leiden" >
              <a href="/security-beveiligingsbedrijf/plaats/leiden">Leiden</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/leiderdorp" >
              <a href="/security-beveiligingsbedrijf/plaats/leiderdorp">Leiderdorp</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/lisse" >
              <a href="/security-beveiligingsbedrijf/plaats/lisse">Lisse</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/nieuwkoop" >
              <a href="/security-beveiligingsbedrijf/plaats/nieuwkoop">Nieuwkoop</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/noordwijk" >
              <a href="/security-beveiligingsbedrijf/plaats/noordwijk">Noordwijk</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/noordwijkerhout" >
              <a href="/security-beveiligingsbedrijf/plaats/noordwijkerhout">Noordwijkerhout</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/oegstgeest" >
              <a href="/security-beveiligingsbedrijf/plaats/oegstgeest">Oegstgeest</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/rijnsburg" >
              <a href="/security-beveiligingsbedrijf/plaats/rijnsburg">Rijnsburg</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/sassenheim" >
              <a href="/security-beveiligingsbedrijf/plaats/sassenheim">Sassenheim</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/teylingen" >
              <a href="/security-beveiligingsbedrijf/plaats/teylingen">Teylingen</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/voorhout" >
              <a href="/security-beveiligingsbedrijf/plaats/voorhout">Voorhout</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/voorschoten" >
              <a href="/security-beveiligingsbedrijf/plaats/voorschoten">Voorschoten</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/warmond" >
              <a href="/security-beveiligingsbedrijf/plaats/warmond">Warmond</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/zoeterwoude" >
              <a href="/security-beveiligingsbedrijf/plaats/zoeterwoude">Zoeterwoude</a>
            </option>
          </optgroup >
          <optgroup  label="Andere Plaatsen">
            <option value="/security-beveiligingsbedrijf/plaats/denhaag" >
              <a href="/security-beveiligingsbedrijf/plaats/denhaag">Den Haag</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/wassenaar" >
              <a href="/security-beveiligingsbedrijf/plaats/wassenaar">Wassenaar</a>
            </option>
            <option value="/security-beveiligingsbedrijf/plaats/zoetermeer" >
              <a href="/security-beveiligingsbedrijf/plaats/zoetermeer">Zoetermeer</a>
            </option>
          </optgroup>
        </select>
        <router-link tag="a" :to="{ name: 'SecurityContact' }" :class="[$store.getters.isSmall ? 'mr-3' : 'ml-5' ]">Privacy</router-link>
        <router-link tag="a" :to="{ name: 'GeneralConditions' }" :class="{'ml-5': !$store.getters.isSmall }">Voorwaarden</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      isLoading: false,
      email: '',
      mailError: 'mailto:info@azurity.nl&subject=Azurity melding pagina: ' + this.$route.fullPath,
      routes: [
        { id: 0, name: 'Home', path: '/security-beveiligingsbedrijf' },
        { id: 0, name: 'Beveiligingsbedrijf', path: '/security-beveiligingsbedrijf/over-azurity' },
        { id: 0, name: 'Veelgestelde vragen', path: '/security-beveiligingsbedrijf/veel-gestelde-vragen' },
        { id: 0, name: 'Partners', path: '/security-beveiligingsbedrijf/partners' },
        { id: 0, name: 'Vacatures', path: '/security-beveiligingsbedrijf/werken-in-de-beveiliging' },
        { id: 0, name: 'Doorverwijs programma', path: '/security-beveiligingsbedrijf/referral' },
        { id: 0, name: 'Informatie', path: '/security-beveiligingsbedrijf/informatie' },
        { id: 1, name: 'Opdrachtgever', path: '/security-beveiligingsbedrijf/informatie/opdrachtgever-of-beveiligingsbedrijf' },
        { id: 1, name: 'Professional', path: '/security-beveiligingsbedrijf/informatie/beveiliger-verkeersregelaar-ehbo' },
        { id: 1, name: 'Beveiliging', path: '/security-beveiligingsbedrijf/informatie/beveiliging' },
        { id: 2, name: 'Objectbeveiliging', path: '/security-beveiligingsbedrijf/informatie/beveiliging/objectbeveiliging' },
        { id: 2, name: 'Evenementenbeveiliging', path: '/security-beveiligingsbedrijf/informatie/beveiliging/evenementenbeveiliging' },
        { id: 2, name: 'Winkelsurveillance', path: '/security-beveiligingsbedrijf/informatie/beveiliging/winkelsurveillance' },
        { id: 2, name: 'Mobiele Surveillance', path: '/security-beveiligingsbedrijf/informatie/beveiliging/mobiele-surveillance' },
        { id: 2, name: 'Persoonsbeveiliging', path: '/security-beveiligingsbedrijf/informatie/beveiliging/persoonsbeveiliging' },
        { id: 2, name: 'Zorgbeveiliging', path: '/security-beveiligingsbedrijf/informatie/beveiliging/zorgbeveiliging' },
        { id: 2, name: 'Hotelbeveiliging', path: '/security-beveiligingsbedrijf/informatie/beveiliging/hotelbeveiliging' },
        { id: 2, name: 'Museumbeveiliging', path: '/security-beveiligingsbedrijf/informatie/beveiliging/museumbeveiliging' },
        { id: 1, name: 'Verkeersregelaars', path: '/security-beveiligingsbedrijf/informatie/verkeersregelaars' },
        { id: 1, name: 'EHBO', path: '/security-beveiligingsbedrijf/informatie/ehbo' },
        { id: 1, name: 'Crowd Management', path: '/security-beveiligingsbedrijf/crowd-management' },
        { id: 1, name: 'CAO Beveiliging', path: '/security-beveiligingsbedrijf/cao-beveiliging' },
        { id: 1, name: 'Collectieve Beveiliging', path: '/security-beveiligingsbedrijf/collectieve-beveiliging' },
        { id: 1, name: 'Operatie Beveiliging', path: '/security-beveiligingsbedrijf/operatie-beveiliging' },
        { id: 0, name: 'Contact', path: '/security-beveiligingsbedrijf/contact' },
        { id: 0, name: 'Inloggen', path: '/security-beveiligingsbedrijf/account/login' },
        { id: 0, name: 'Aanmelden', path: '/security-beveiligingsbedrijf/account/register' },
      ]
    }
  },
  mounted() {
    let app = document.getElementById("app"),
      footer = document.getElementById("theFooter");

    app.style.paddingBottom = footer.offsetHeight + 'px';
    
    window.addEventListener('resize', (ev) => {
      app.style.paddingBottom = footer.offsetHeight + 'px';
      this.$store.dispatch('SET_SMALL');
    });
  },
  methods: {
    signUpNewsletter() {
      if(!this.email)
        return;

      this.isLoading = true;
      this.$http.post('api/NewsLetter', JSON.stringify(this.email)).then(() => {
        this.isLoading = false;
        this.email = '';
      }).catch(() => {
        this.isLoading = false;
      })
    },
    navigate(ev) 
    {
      return this.$router.push({ path: ev.currentTarget.value });
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#theFooter
{
  font-size: 20px;
  line-height: 1.5;
  position: absolute;
    bottom: 0;
    width: 100%;

    .nav-menu{
      width: auto;
      color: $darkColor;
      optgroup,
      option {
        color: $darkColor;
      }
    }
    .footer-nav-label {
      display: none;
    }
}

a
{
  color: $lightColor;
  font-weight: bold;
  text-decoration: none;
}
a:hover{
  color: #fff;
  text-decoration: none;
}

ul{
  list-style:none;
}

.inline
{
  display: inline-block;
}
.right
{
  float:right;
}
.full-width
{
  width: 100%
}

.icon {
  opacity: .6
}
.icon:hover {
  opacity: 1
}

</style>
